import React, { useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import Colors from "../../../stories/assets/Colors";
import Fonts from "../../../stories/assets/Fonts";
import { Tabs } from "../../../stories/Tabs/Tabs";
import classes from "./UserFeedback.module.css";
import tabsClasses from "../../../stories/Tabs/Tabs.module.css";
import { AdminUserFeedback } from "../../../stories/AdminUserFeedback/AdminUserFeedback";
import Layout from "../Layout/Layout";
import {
  BlockViewGrayIcon,
  BlockViewBlueIcon,
  ListIconBlue,
  ListIconGray,
} from "../../../constant/imagePath";
import { ButtonGroup } from "../../../stories/ButtonGroup/ButtonGroup";
import { InputWithSearchIcon } from "../../../stories/InputWithSearchIcon/InputWithSearchIcon";
import { DropDown } from "../../../stories/DropDown/DropDown";
import { TableCell, TableRow } from "@mui/material";
import { AdminTable } from "../../../stories/AdminTable/AdminTable";
import StarRatings from "react-star-ratings";
import dropdownClasses from '../../../stories/DropDown/DropDown.module.css'

const UserFeedback = () => {
  const [tabsState, setTabsState] = useState();
  const [isView, setIsView] = useState("block");
  const [search, setSearch] = useState("");
  const [rating, setRating] = useState("");
  const [time, setTime] = useState("");

  const tabsData = [
    { label: "All" },
    { label: "5-stars" },
    { label: "4-stars" },
    { label: "3-stars" },
    { label: "2-stars" },
    { label: "1-stars" },
  ];
  const tableHeadings = [
    { title: "Feature name" },
    { title: "Date implemented" },
    { title: "Number of feedback", filter: true },
    { title: "Average rating", filter: true },
  ];

  const dummyData = [
    {
      name: "Application review",
      date: "-",
      numberOfFeedbacks: 16,
      rating: 4.0,
    },
    {
      name: "Ability to create group chats",
      date: "20 Aug, 2021",
      numberOfFeedbacks: 16,
      rating: 4.0,
    },
  ];

  const AdminUserFeedbackArr = [1, 2, 3, 4];

  return (
    <div className={classes.AdminTableMain}>
      <style>{`.${tabsClasses.TabsContainer} ul{
        justify-content:space-between;
      }
      .${dropdownClasses.reactSelect} > div {
        z-index: 3;
      }

      
      `}</style>
      <Layout />
      <div className={classes.tableMain}>
        <Container fluid className={classes.container}>
          <h3
            className={classes.marginBlock24}
            style={{ ...Fonts.h3, color: Colors.neutralShadesOfNero }}
          >
            User feedback
          </h3>
          {/* <Tabs
              state={tabsState}
              setState={setTabsState}
              tabsData={tabsData}
            /> */}
          {/* Search Row */}
          <div className={classes.filterRow}>
            <div className={classes.searchBox}>
              <InputWithSearchIcon
                setter={setSearch}
                state={search}
                placeholder={"Search..."}
              />
            </div>
            <div className={classes.dropdownBox}>
              <DropDown
                placeholder={"All Rates"}
                state={rating}
                setter={setRating}
                options={[
                  { label: 'All Rates', value: 'all-rates' },
                  { label: '1 star', value: 'all-rates' },
                  { label: '2 stars', value: '2-stars' },
                  { label: '3 stars', value: '3-stars' },
                  { label: '4 stars', value: '4-stars' },
                  { label: '5 stars', value: '5-stars' },
                ]}
              />
            </div>
            <div className={classes.dropdownBox}>
              <DropDown
                placeholder={"All time"}
                state={time}
                setter={setTime}
              />
            </div>
            <div>
              <ButtonGroup
                customStyle={{
                  backgroundColor: Colors.white,
                  padding: "2px",
                  justifyContent: "center",
                  width: "max-content",
                }}
                btnIcon1={
                  isView === "block" ? BlockViewBlueIcon : BlockViewGrayIcon
                }
                btnIcon2={isView === "list" ? ListIconBlue : ListIconGray}
                onClick1={() => setIsView("block")}
                onClick2={() => setIsView("list")}
              />
            </div>
          </div>
          <Row className={`g-4 gy-4 ${classes.marginTop10}`}>
            {isView == "block" ? (
              AdminUserFeedbackArr?.map((item, index) => (
                <Col md={6}>
                  <AdminUserFeedback />
                </Col>
              ))
            ) : (
              <Col md={12}>
                <AdminTable
                  headings={tableHeadings}
                  renderDataWithElement={dummyData?.map((item) => (
                    <TableRow
                      sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                    >
                      <TableCell component="th" scope="row">
                        <h6
                          style={{
                            ...Fonts.b3,
                            color: Colors.neutralShadesOfNero,
                          }}
                        >
                          {item?.name}
                        </h6>
                      </TableCell>

                      <TableCell>
                        <p
                          style={{
                            ...Fonts.p1,
                            color: Colors.neutralShadesOfNero,
                            textTransform: "capitalize",
                          }}
                        >
                          {item?.date}
                        </p>
                      </TableCell>
                      <TableCell>
                        <p
                          style={{
                            ...Fonts.p1,
                            color: Colors.neutralShadesOfNero,
                          }}
                        >
                          {item?.numberOfFeedbacks}
                        </p>
                      </TableCell>
                      <TableCell>
                        <div className={classes.rating}>
                          <p
                            style={{
                              ...Fonts.p1,
                              color: Colors.neutralShadesOfNero,
                            }}
                          >
                            {item?.rating?.toFixed(1)}
                          </p>
                          <StarRatings
                            starRatedColor={Colors.mainShadeOfRed}
                            starEmptyColor={Colors.neutralShadesOfGainsboro}
                            rating={item?.rating}
                            starDimension={"16px"}
                            starSpacing={"1px"}
                            numberOfStars={5}
                          />
                        </div>
                      </TableCell>
                    </TableRow>
                  ))}
                />
              </Col>
            )}
          </Row>
        </Container>
      </div>
    </div>
  );
};

export default UserFeedback;
